<template>
  <div>
    <a-modal v-model="visible" title="Edit lesson plan" width="800px">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Update Lesson Plan</a-button>
      </template>

      <a-spin :spinning="modalLoading" tip="Loading...">
        <a-form class="mb-4 row" :form="form">
          <a-form-item label="Session" class="col-md-6">
            <a-select
              v-decorator="[
                'session_id',
                {rules: [{ required: true, message: 'Please select a session' }]},
              ]"
              placeholder="Select a session"
              @change="handleSessionChange"
            >
              <a-select-option v-for="s in schoolSessions" :key="s.id" :value="s.id">
                {{ s.name }}
                <small class="text-primary ml-2">{{ currentSession.id === s.id ? 'Current' : '' }}</small>
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Class" class="col-md-6">
            <a-select
              v-decorator="[
                'class_id',
                {rules: [{ required: true, message: 'Please select a class' }]},
              ]"
              placeholder="Select a class"
              @change="handleClassChange"
            >
              <a-select-option v-for="c in classes" :key="c.id" :value="c.id">
                {{ c.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Subject" class="col-md-6">
            <a-select
              v-decorator="[
                'subject_id',
                {rules: [{ required: true, message: 'Please select a subject' }]},
              ]"
              placeholder="Select a subject"
            >
              <a-select-option v-for="s in subjects" :key="s.id" :value="s.id">
                {{ s.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Name" class="col-md-6">
            <a-input
              v-decorator="[
                'name',
                {rules: [{ required: true, message: 'Please input a name' }]},
              ]"
              placeholder="Enter lesson plan name"
            />
          </a-form-item>

          <a-form-item label="Start Date" class="col-md-6">
            <a-date-picker
                v-decorator="[
                'start_date',
                {rules: [{ required: true, message: 'Please input a start date' }]},
                ]"
                :format=dateFormat />
          </a-form-item>
          <a-form-item label="End Date" class="col-md-6">
            <a-date-picker
                v-decorator="[
                'end_date',
                {rules: [{ required: true, message: 'Please input an end date' }]},
                ]"
                :format=dateFormat />
          </a-form-item>

          <div class="col-md-12">
            <hr/>
            <h6>Topics</h6>
            <div v-for="(topicKey, topicIndex) in topicKeys" :key="topicKey">
              <div class="row">
                <a-form-item :label="`Unit ${topicIndex + 1}`" class="col-md-4">
                  <a-input
                    v-decorator="[
                      `topics[${topicKey}].topic_name`,
                      {rules: [{ required: true, message: 'Please input unit name' }]},
                    ]"
                    placeholder="Enter unit name"
                  />
                </a-form-item>
                <a-form-item label="Academic Term" class="col-md-3">
                  <a-select
                    v-decorator="[
                      `topics[${topicKey}].academic_term_id`,
                      {rules: [{ required: true, message: 'Please select an academic term' }]},
                    ]"
                    placeholder="Select an academic term"
                  >
                    <a-select-option v-for="term in academicTerms" :key="term.id" :value="term.id">
                      {{ term.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
                 <!-- Total Mark -->
                  <a-form-item label="Total Mark" class="col-md-2">
                    <a-input-number
                      v-decorator="[
                        `topics[${topicKey}].marks`,
                        { initialValue: 0, rules: [{ required: true, message: 'Enter total mark' }]},
                        ]"
                        :min="0"
                        placeholder="Mark"
                        style="width: 100%;"
                    />
                  </a-form-item>

              <!-- Total Period/Day -->
              <a-form-item label="Total Period/Day" class="col-md-2">
                <a-input-number
                  v-decorator="[
                    `topics[${topicKey}].total_periods`,
                    { initialValue: 1, rules: [{ required: true, message: 'Enter total period/day' }]},
                    ]"
                  :min="1"
                  placeholder="Period"
                  style="width: 100%;"
                />
              </a-form-item>
                <div class="col-md-1">
                  <a-icon
                    class="dynamic-delete-button"
                    type="minus-circle-o"
                    @click="() => removeTopic(topicKey)"
                  />
                </div>
              </div>

              <div v-for="(subTopicKey, subTopicIndex) in subTopicKeys[topicKey]" :key="subTopicKey">
                 <div class="row">
                <a-form-item :label="`Unit/Chapter ${subTopicIndex + 1}`" style="margin-left: 40px;" class="col-md-6">
                  <a-input
                    v-decorator="[
                      `topics[${topicKey}].sub_topics[${subTopicKey}].sub_topic_name`,
                      {rules: [{ required: true, message: 'Please input a unit/chapter name' }]},
                    ]"
                    placeholder="Enter unit/chapter name"
                  />
                  </a-form-item>
                  <a-form-item label="Estimated Period" class="col-md-3">
                  <a-input-number
                    v-decorator="[
                      `topics[${topicKey}].sub_topics[${subTopicKey}].estimated_periods`,
                      {initialValue: 1, rules: [{ required: true, message: 'Please input estimated period' }]},
                    ]"
                    :min="1"
                    placeholder="Period"
                  />
                  </a-form-item>
                  <div class="col-md-2">
                  <a-icon
                    class="dynamic-delete-button"
                    type="minus-circle-o"
                    @click="() => removeSubTopic(topicKey, subTopicKey)"
                  />
                  </div>
                  </div>
              </div>
              <a-button type="dashed" style="margin-left: 40px;" @click="() => addSubTopic(topicKey)">
                <a-icon type="plus" /> Add Unit/Chapter
              </a-button>
            </div>
            <a-button type="dashed" @click="addTopic">
              <a-icon type="plus" /> Add Unit
            </a-button>
          </div>

        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { find } from 'lodash'
import moment from 'moment'

export default {
  name: 'EditLessonPlan',
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      modalLoading: false,
      visible: false,
      classes: [],
      subjects: [],
      lessonPlanId: null,
      schoolSessions: [],
      selectedSession: undefined,
      academicTerms: [],
      topicKeys: [],
      nextTopicKey: 0,
      subTopicKeys: {},
      nextSubTopicKey: 0,
      dateFormat: 'YYYY-MM-DD',
    }
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  mounted() {
    this.$eventBus.$on('openLessonPlanEditModal', (id) => {
      this.showModal(id)
    })
  },
  beforeDestroy() {
    this.$eventBus.$off('openLessonPlanEditModal')
  },
  methods: {
    fetchSessions() {
      this.$http.get('/api/session').then(({ data }) => {
        this.schoolSessions = data.data
      })
    },
    fetchClasses() {
      this.$http.get('/api/class').then(({ data }) => {
        this.classes = data.data
      })
    },
    fetchAcademicTerms(sessionId) {
      this.$http.get(`/api/lesson-plan/academic-terms?session_id=${sessionId}`).then(({ data }) => {
        this.academicTerms = data.data
      })
    },
    handleSessionChange(sessionId) {
      this.selectedSession = sessionId
      this.fetchClasses()
      this.fetchAcademicTerms(sessionId)
    },
    handleClassChange(classId) {
      this.fetchSubjects(classId)
    },
    fetchSubjects(classId) {
      this.$http.get(`/api/subject?class_id=${classId}`).then(({ data }) => {
        this.subjects = data.data
      })
    },
    addTopic() {
      const newKey = this.nextTopicKey++
      this.topicKeys = this.topicKeys.concat(newKey)
      this.$set(this.subTopicKeys, newKey, [])
    },
    removeTopic(k) {
      this.topicKeys = this.topicKeys.filter(key => key !== k)
      this.$delete(this.subTopicKeys, k)
    },
    addSubTopic(topicKey) {
      const newSubKey = this.nextSubTopicKey++
      this.subTopicKeys[topicKey] = this.subTopicKeys[topicKey].concat(newSubKey)
    },
    removeSubTopic(topicKey, subTopicKey) {
      this.subTopicKeys[topicKey] = this.subTopicKeys[topicKey].filter(key => key !== subTopicKey)
    },
    showModal(id) {
      this.visible = true
      this.lessonPlanId = id
      this.form.resetFields()
      this.topicKeys = []
      this.subTopicKeys = {}
      this.nextTopicKey = 0
      this.nextSubTopicKey = 0
      this.subjects = []
      this.academicTerms = []
      this.modalLoading = true

      this.$http.get(`/api/lesson-plan/plans/${id}`).then(({ data }) => {
        const lessonPlan = data.data

        const sessionsPromise = this.$http.get('/api/session')
        const classesPromise = this.$http.get('/api/class')
        const academicTermsPromise = this.$http.get(`/api/lesson-plan/academic-terms?session_id=${lessonPlan.session_id}`)
        const subjectsPromise = this.$http.get(`/api/subject?class_id=${lessonPlan.class_section_id}`)

        Promise.all([sessionsPromise, classesPromise, academicTermsPromise, subjectsPromise]).then(
          ([sessionsRes, classesRes, academicTermsRes, subjectsRes]) => {
            this.schoolSessions = sessionsRes.data.data
            this.classes = classesRes.data.data
            this.academicTerms = academicTermsRes.data.data
            this.subjects = subjectsRes.data.data

            this.selectedSession = lessonPlan.session_id

            const topics = lessonPlan.topics || []
            this.topicKeys = topics.map((_, index) => index)
            this.nextTopicKey = topics.length
            this.subTopicKeys = {}
            let subTopicCounter = 0
            topics.forEach((topic, topicIndex) => {
              const subTopics = topic.sub_topics || []
              this.$set(this.subTopicKeys, topicIndex, subTopics.map((_, subIndex) => subIndex))
              subTopicCounter += subTopics.length
            })
            this.nextSubTopicKey = subTopicCounter

            this.$nextTick(() => {
              const fieldsData = {
                ...lessonPlan,
                start_date: lessonPlan.start_date ? moment(lessonPlan.start_date, this.dateFormat) : undefined,
                end_date: lessonPlan.end_date ? moment(lessonPlan.end_date, this.dateFormat) : undefined,
              }
              this.form.setFieldsValue(fieldsData)
              this.modalLoading = false
            })
          }
        ).catch(() => {
          this.modalLoading = false
        })
      }).catch(() => {
        this.modalLoading = false
      })
    },
    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          values.topics = values.topics.filter(t => t)
          values.topics.forEach(t => {
            if (t.sub_topics) {
              t.sub_topics = t.sub_topics.filter(st => st)
            }
          })

          if (values.start_date) {
            values.start_date = values.start_date.format('YYYY-MM-DD')
          }
          if (values.end_date) {
            values.end_date = values.end_date.format('YYYY-MM-DD')
          }

          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to update the lesson plan!`,
            onOk: () => {
              this.$http
                .put(`/api/lesson-plan/plans/${this.lessonPlanId}`, values)
                .then(({ data }) => {
                  this.$emit('edited')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Lesson plan successfully updated',
                    description: `${data.data.name} updated successfully!`,
                  })
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.visible = false
    },
  },
}
</script>
<style scoped>
.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}
.dynamic-delete-button:hover {
  color: #777;
}
</style>
